// extracted by mini-css-extract-plugin
export default {"container":"CommentsList_container__UkIcL"};